import React from "react";
import axios from "axios";
import url from '@/constants/url';

const ErrorLog = (error,errorInfo) => {
    const errorLog = async(error,errorInfo) => {
        try{
            await axios.post(`${url.admin_api}error/log/`,
                {error: {name: error.name, message: error.message,stack:error.stack}, errorInfo:errorInfo, href: window.location.href});
        }catch(e) {}
    }

    errorLog(error,errorInfo);

    return null
}

export default ErrorLog;
